import { render, staticRenderFns } from "./gamerStatus.vue?vue&type=template&id=3c088822&scoped=true"
import script from "./gamerStatus.vue?vue&type=script&lang=js"
export * from "./gamerStatus.vue?vue&type=script&lang=js"
import style0 from "./gamerStatus.vue?vue&type=style&index=0&id=3c088822&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c088822",
  null
  
)

export default component.exports